import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCategory } from "../../api/category.service";

export const fetchCategory = createAsyncThunk("category/fetchCategory", async (data, { rejectWithValue }) => {
  const category = await getCategory();
  console.log("****+category -> ", category);
  return category.data;
});

const fetchCategoryReducer = {
  [fetchCategory.pending]: (state, action) => {
    state.isLoading = true;
    state.error = null;
  },
  [fetchCategory.fulfilled]: (state, action) => {
    const category = action.payload.results;
    state.value = category;
    state.error = null;
    state.isLoading = false;
  },
  [fetchCategory.rejected]: (state, action) => {
    state.isLoading = false;
    state.error = action.payload;
  },
};


export const categorySlice = createSlice({
    name: "category",
    initialState: {
      value: [],
      error: null,
      editCategoryValue: null,
      isLoading: false,
      isLoadingCreate: false,
    },
    reducers: {
      cleanCategory: (state, action) => {
        state.value = [];
      },
      /** Optimistically update a category or subcategory in place (translations, emoji). */
      updateCategoryOrSubcategoryInPlace: (state, action) => {
        const { _id, translations, emoji, parent } = action.payload;
        if (!_id) return;
        const idStr = String(_id);
        if (parent) {
          const cat = state.value.find((c) => String(c._id) === String(parent));
          const sub = cat?.subCategories?.find((s) => String(s._id) === idStr);
          if (sub) {
            sub.translations = translations ?? sub.translations;
            sub.emoji = emoji !== undefined ? emoji : sub.emoji;
            sub.title = translations?.find((t) => t?.lang === 'en')?.trans ?? sub.title;
          }
        } else {
          const cat = state.value.find((c) => String(c._id) === idStr);
          if (cat) {
            cat.translations = translations ?? cat.translations;
            cat.emoji = emoji !== undefined ? emoji : cat.emoji;
            cat.title = translations?.find((t) => t?.lang === 'en')?.trans ?? cat.title;
          }
        }
      },
      /** Remove category or subcategory by _id. */
      removeCategoryOrSubcategory: (state, action) => {
        const { _id, parent } = action.payload;
        if (!_id) return;
        const idStr = String(_id);
        if (parent) {
          const cat = state.value.find((c) => String(c._id) === String(parent));
          if (cat?.subCategories) {
            state.value = state.value.map((c) => {
              if (String(c._id) !== String(parent)) return c;
              return {
                ...c,
                subCategories: (c.subCategories || []).filter((s) => String(s._id) !== idStr),
              };
            });
          }
        } else {
          state.value = (state.value || []).filter((c) => String(c._id) !== idStr);
        }
      },
      /** Reorder root categories by new order (array of _id strings). */
      reorderCategories: (state, action) => {
        const { categoryIds } = action.payload;
        if (!categoryIds?.length || !state.value?.length) return;
        const idToCat = new Map(state.value.map((c) => [String(c._id), c]));
        state.value = categoryIds
          .map((id) => idToCat.get(String(id)))
          .filter(Boolean);
      },
      /** Move category or subcategory to first position in the list. */
      moveCategoryOrSubcategoryToFirst: (state, action) => {
        const { _id, parent } = action.payload;
        if (!_id) return;
        const idStr = String(_id);
        if (parent) {
          const cat = state.value.find((c) => String(c._id) === String(parent));
          const subIdx = cat?.subCategories?.findIndex((s) => String(s._id) === idStr);
          if (cat && subIdx != null && subIdx > 0) {
            const [sub] = cat.subCategories.splice(subIdx, 1);
            cat.subCategories.unshift(sub);
          }
        } else {
          const catIdx = state.value.findIndex((c) => String(c._id) === idStr);
          if (catIdx > 0) {
            const [cat] = state.value.splice(catIdx, 1);
            state.value.unshift(cat);
          }
        }
      },
    },
    extraReducers: {
      ...fetchCategoryReducer,
    },
  });
  
  export const { cleanCategory, updateCategoryOrSubcategoryInPlace, removeCategoryOrSubcategory, reorderCategories, moveCategoryOrSubcategoryToFirst } = categorySlice.actions;
  
  export default categorySlice.reducer;